<template>
  <v-dialog
    persistent
    v-model="get_dialogMain.dialog"
    width="800px"
    justify-center
  >
    <v-toolbar dense dark color="blue darken-2">
      <v-toolbar-title>
        <h3 v-if="get_dialogMain.type == 'create'">Nuevo Permiso</h3>
        <h3 v-else>Editar Permiso</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <PermisoForm
      :model="permiso"
      :on-success="savePermiso"
      :on-cancel="cancel"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PermisoForm from '@/components/forms/PermisoForm'
export default {
  data: () => ({
    permiso: {
      descripcion: ''
    }
  }),
  components: {
    PermisoForm
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesAction']),
    savePermiso (model) {
      this.permiso = model
      this.getUrl('POST/permisos/add')
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesAction({ url: router, data: this.permiso })
      } else {
        this.getUrlServices()
      }
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/permisos/add')
    },
    get_object (val) {
      console.log(val)
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Permiso agregado.!'
      })
      this.SET_DATA_MAIN(val)
      this.cancel()
    }
  }
}
</script>

<style></style>
